// ANGULAR
import { Injectable } from '@angular/core';

// NGRX
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';

// RXJS
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

// SERVICES
import { GlobalService } from '../services/global.service';

// ACTIONS AND STATES
import { State } from '../../root-state';
import * as globalActions from './actions';

/**
 * This effect is for listen global actions, execute global service call and dispatch in global reducer.
 * For global api call purpose.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) popup notification effect create
 */

@Injectable()
export class GlobalEffects {
  constructor(private readonly actions$: Actions, private readonly store: Store<State>, private readonly globalService: GlobalService) { }

  /**
   * Popup Notification Effect
   * @param type : POPUP_NOTIFICATION action name.
   * @param payload : PopupNotification object to display popup in ui.
   * @returns Empty action dispatch to reducer.
   */
  PopupNotificationEffect$ = createEffect(() => this.actions$.pipe(
    ofType<globalActions.PopupNotificationAction>(globalActions.ActionTypes.POPUP_NOTIFICATION),
    switchMap(action => {
      return of(new globalActions.EmptyAction({}));
    }),
  ), { dispatch: false });

  /**
   * Failure Effect
   * @param type : FAILURE action name.
   * @param payload : object for handle global failure.
   * @returns Empty action dispatch to reducer.
   */
  FailureEffect$ = createEffect(() => this.actions$.pipe(
    ofType<globalActions.FailureAction>(globalActions.ActionTypes.FAILURE),
    switchMap(action => {
      return of(new globalActions.EmptyAction({}));
    }),
  ), { dispatch: false });
}
